import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { Download, Upload } from 'react-feather';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  UncontrolledTooltip,
} from 'reactstrap';

import useI18n from 'hooks/use-i18n';
import { useUnit } from 'hooks/units/index';

import styles from 'styles/Unit.module.scss';
import { downloadFile, parseHtml } from 'helpers/index';
import ImageLoader from '../../../../../../../../components/Image';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';
import ListTableRow from 'components/Table/ListTableRow';
import { bytesToSize } from 'helpers/number';
import LoadingOverlay from 'react-loading-overlay';

const ModalAnswer = ({ open, toggleModal }) => {
  const i18n = useI18n();
  const unitSelected = useUnit();
  const assignment = unitSelected?.assignment;
  const file = assignment?.file;
  const [isLazyLoad, setIsLazyLoad] = useState(false);
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  async function handleDownload(file) {
    try {
      setIsLazyLoad(true);
      await downloadFile(file?.path, file?.originalname);
      setIsLazyLoad(false);
    } catch (error) {}
  }

  const renderContent = () => {
    if (assignment?.content) {
      return (
        <p
          className="overflow-x-auto"
          style={{ overflowWrap: 'break-word', whiteSpace: 'pre-line' }}
        >
          {parseHtml(assignment?.content)}
        </p>
      );
    }

    if (file?.mimetype === 'audio/ogg') {
      return (
        <div className="d-flex justify-content-center">
          <audio controls>
            <source src={file?.path} type="audio/ogg" />
            Your browser does not support the audio tag.
          </audio>
        </div>
      );
    }
    const availableVideoType = ['video/mp4', 'video/webm', 'video/ogg'];

    if (availableVideoType?.indexOf(file?.mimetype) !== -1) {
      return (
        <div className="d-flex justify-content-center">
          <video controls width="300" autoPlay>
            <source src={file?.path} type={file?.mimetype} />
            Your browser does not support HTML video.
          </video>
        </div>
      );
    }

    if (file?.mimetype?.includes('image/png')) {
      return (
        <div className="d-flex justify-content-center">
          <ImageLoader src={file?.path} width="300" height="300" />
        </div>
      );
    }
    return (
      <div className="overflow-x-auto">
        <LoadingOverlay
          active={isLazyLoad}
          spinner
          styles={{
            overlay: (base) => ({
              ...base,
              background: 'rgb(187 181 181 / 50%)',
              zIndex: 10,
              top: 7,
            }),
          }}
        >
          <Table className="table-header-custom " responsive>
            {' '}
            <thead>
              <tr>
                <th className="text-center">No.</th>
                <th>Name</th>
                <th>Size</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <ListTableRow col={4} length={file?._id ? 1 : file?.length}>
                {' '}
                {file?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{item?.originalname}</td>
                    <td className="text-center">{bytesToSize(item?.size)}</td>
                    <td className="text-center">
                      <Button.Ripple
                        className="btn-icon px-05 py-05"
                        color="flat-dark"
                        id={`id-${item?._id}${index}`}
                        onClick={() => handleDownload(item)}
                      >
                        <Download size={15} />
                        <UncontrolledTooltip
                          placement="top"
                          target={`id-${item?._id}${index}`}
                        >
                          Download
                        </UncontrolledTooltip>
                      </Button.Ripple>
                    </td>
                  </tr>
                ))}
              </ListTableRow>
            </tbody>
          </Table>
        </LoadingOverlay>
      </div>
    );
  };

  return (
    <Modal isOpen={open} className="modal-dialog-centered" size="lg">
      <ModalHeader>Your answer</ModalHeader>
      <ModalBody>{renderContent()}</ModalBody>
      <ModalFooter className="px-05 py-05">
        <button
          className="btn-bg-color"
          onClick={toggleModal}
          // outline
          style={{
            backgroundColor: `${colorStatus}`,
            color: `${colorTextStatus}`,
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.borderColor = colorStatus;
            e.target.style.color = colorStatus;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = colorStatus;
            e.target.style.color = colorTextStatus;
          }}
        >
          {i18n.t('cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

ModalAnswer.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default ModalAnswer;
